import { Box, LinearProgress, Typography } from "@mui/material";
import { EndorsedSkill } from "../../../types";

type SkillMeterProps = {
  skill: EndorsedSkill;
};

const SkillMeter = ({ skill: { title, percentage, count } }: SkillMeterProps) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", rowGap: "8px" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-end",
        }}
      >
        <Typography variant="body12Bold">{title}</Typography>
        <Typography variant="body10Bold">
          {percentage || 0 + "%"}⋅{count}
        </Typography>
      </Box>
      <LinearProgress
        sx={{
          height: "16px",
          borderRadius: "4px",
          backgroundColor: "#E0E0E0",
          "& .MuiLinearProgress-bar": {
            backgroundColor: "#106048",
          },
        }}
        variant="determinate"
        value={percentage || 0}
      />
    </Box>
  );
};

export default SkillMeter;
